import * as React from 'react';
import { Button, Icon } from '@symphony-ui/uitoolkit-components';
import FindSourceButton from '../../../../pages/parties/FindSourceButton';
const BookrunnersEntry = ({ bookrunner, roleOptions, setInitialBookrunner, transactionId }) => {
    const name = React.useMemo(() => {
        if (bookrunner.override?.ignore) {
            return (React.createElement("div", null, "IGNORE"));
        }
        if (bookrunner.override?.name) {
            return (React.createElement("div", { className: 'co-overriden-inverse' }, bookrunner.override.name));
        }
        if (bookrunner.name !== undefined) {
            return (React.createElement("div", { style: { fontWeight: 'bold' } }, bookrunner.name));
        }
        return (React.createElement("div", { className: 'co-br' }, bookrunner.name));
    }, [bookrunner.name, bookrunner.override?.ignore, bookrunner.override?.name]);
    const onClick = React.useCallback(() => {
        setInitialBookrunner(bookrunner);
    }, [bookrunner, setInitialBookrunner]);
    const variant = React.useMemo(() => bookrunner.partyId === undefined ? 'primary-destructive' : 'secondary', [bookrunner.partyId]);
    const roles = React.useMemo(() => {
        if (bookrunner.override?.roles !== undefined) {
            return (React.createElement("div", { className: 'co-overriden-inverse' }, roleOptions.filter(o => 'value' in o && bookrunner.override?.roles?.includes(o.value)).map(o => o.label).join(", ")));
        }
        return (React.createElement("div", null, roleOptions.filter(o => 'value' in o && bookrunner.roles?.includes(o.value)).map(o => o.label).join(", ")));
    }, [bookrunner.override?.roles, bookrunner.roles, roleOptions]);
    return (React.createElement(React.Fragment, null,
        name,
        React.createElement("div", null, bookrunner.names?.join(", ")),
        roles,
        React.createElement("div", { style: { marginRight: '0.25rem' } },
            React.createElement(Button, { iconButton: true, onClick: onClick, title: '', size: "small", variant: variant },
                React.createElement(Icon, { iconName: 'plus' }))),
        React.createElement(FindSourceButton, { name: bookrunner.names?.[0], transactionId: transactionId })));
};
export default BookrunnersEntry;
